/* Alkan-Kette auf der Passwort-Sperrseite (snippets/oysi-alkan-kette.liquid).
   n Zeichen im Passwortfeld = n-Alkan CnH2n+2 als Zickzack-Kette. Gelesen
   wird nur `value.length` in Codepunkten, nie der Inhalt; alle Texte kommen
   aus den versteckten Listen des Snippets. */
(function () {
  'use strict';

  const SVG = 'http://www.w3.org/2000/svg';
  // Ab hier waechst nur noch die Formel; eine gestrichelte Bindung deutet an,
  // dass die Kette weitergeht. Mehr Atome waeren auf 390 px nur noch Punkte.
  const MAX_ATOME = 30;
  const BINDUNG = 30;
  // Tetraederwinkel 109,5°: jede Bindung steht 54,75° gegen die Senkrechte.
  const HALB = ((109.5 / 2) * Math.PI) / 180;
  const DX = BINDUNG * Math.sin(HALB);
  const DY = BINDUNG * Math.cos(HALB);
  const RADIUS = 7;
  const RAND = RADIUS + 2;
  const HOEHE = 2 * RAND + DY;

  const zahl = (x) => String(Math.round(x * 10) / 10);

  function svg(name, attribute) {
    const e = document.createElementNS(SVG, name);
    for (const [k, v] of Object.entries(attribute)) e.setAttribute(k, v);
    return e;
  }

  function tief(text) {
    const s = document.createElement('sub');
    s.textContent = text;
    return s;
  }

  // CH4 statt C1H4: die 1 schreibt man nicht.
  function formel(ziel, n) {
    ziel.replaceChildren('C', ...(n > 1 ? [tief(String(n))] : []), 'H', tief(String(2 * n + 2)));
  }

  function zeichne(kette, n, gewachsen) {
    const m = Math.min(n, MAX_ATOME);
    const weiter = n > MAX_ATOME;
    const punkte = [];
    for (let i = 0; i < m; i++) {
      // Methan allein sitzt mittig, sonst Zickzack oben/unten.
      const y = m === 1 ? RAND + DY / 2 : RAND + (i % 2) * DY;
      punkte.push([RAND + i * DX, y]);
    }
    const breite = 2 * RAND + Math.max(m - 1, 0) * DX + (weiter ? DX : 0);
    kette.setAttribute('viewBox', `0 0 ${zahl(breite)} ${zahl(HOEHE)}`);
    kette.setAttribute('width', zahl(breite));
    kette.setAttribute('height', zahl(HOEHE));

    const teile = [];
    for (let i = 1; i < punkte.length; i++) {
      const [x1, y1] = punkte[i - 1];
      const [x2, y2] = punkte[i];
      teile.push(svg('line', { class: 'oysi-alkan__bindung', x1: zahl(x1), y1: zahl(y1), x2: zahl(x2), y2: zahl(y2) }));
    }
    if (weiter) {
      const [x, y] = punkte[m - 1];
      const y2 = m % 2 ? y + DY : y - DY;
      teile.push(svg('line', { class: 'oysi-alkan__bindung oysi-alkan__bindung--weiter', x1: zahl(x), y1: zahl(y), x2: zahl(x + DX), y2: zahl(y2) }));
    }
    punkte.forEach(([x, y], i) => {
      const neu = !weiter && i === m - 1;
      const g = svg('g', { class: 'oysi-alkan__c' + (neu ? ' oysi-alkan__c--neu' : '') + (neu && gewachsen ? ' oysi-alkan__c--pop' : '') });
      g.append(
        svg('circle', { class: 'oysi-alkan__atom', cx: zahl(x), cy: zahl(y), r: RADIUS }),
        svg('circle', { class: 'oysi-alkan__glanz', cx: zahl(x - RADIUS * 0.3), cy: zahl(y - RADIUS * 0.3), r: zahl(RADIUS * 0.35) })
      );
      teile.push(g);
    });
    kette.replaceChildren(...teile);
  }

  function init(block) {
    const form = block.closest('form');
    const feld = form && form.querySelector('input[type="password"]');
    if (!feld) return;
    const kette = block.querySelector('[data-oysi-alkan-kette]');
    const name = block.querySelector('[data-oysi-alkan-name]');
    const formelZiel = block.querySelector('[data-oysi-alkan-formel]');
    const fakt = block.querySelector('[data-oysi-alkan-fakt]');
    const leer = fakt.textContent;
    const namen = Array.from(block.querySelectorAll('[data-oysi-alkan-namen] li'), (li) => li.textContent);
    const fakten = Array.from(block.querySelectorAll('[data-oysi-alkan-fakten] li'), (li) => ({
      ab: Number(li.dataset.ab),
      text: li.textContent,
    })).sort((a, b) => a.ab - b.ab);
    let vorher = 0;

    function zeige() {
      const n = Array.from(feld.value).length;
      block.classList.toggle('oysi-alkan--leer', n === 0);
      if (n === 0) {
        // Auch die Masse weg: die Breite des letzten Bildes verriete die
        // vorherige Laenge (Codex 17.10.).
        kette.replaceChildren();
        for (const a of ['viewBox', 'width', 'height']) kette.removeAttribute(a);
        name.textContent = '';
        formelZiel.replaceChildren();
        fakt.textContent = leer;
      } else {
        zeichne(kette, n, n > vorher);
        name.textContent = namen[n - 1] || '';
        formel(formelZiel, n);
        const stufe = fakten.filter((f) => f.ab <= n).pop();
        fakt.textContent = stufe ? stufe.text : '';
      }
      vorher = n;
    }

    feld.addEventListener('input', zeige);
    // Werte ohne `input`-Ereignis: Wiederherstellung des Formulars, ein
    // Passwortmanager, `reset` (erst nach dessen Standardaktion).
    feld.addEventListener('focus', zeige);
    window.addEventListener('pageshow', zeige);
    form.addEventListener('reset', () => setTimeout(zeige));
    // Vom Browser wiederhergestellter oder vorab gefuellter Wert.
    vorher = Array.from(feld.value).length;
    zeige();
  }

  document.querySelectorAll('[data-oysi-alkan]').forEach(init);
})();
